import { Box, Button } from '@mui/material';
import { useFormik } from 'formik';
import { CustomNumberInput, NumberInputButton } from '../../components';

const FormPrecio = ({ prices, onClose, onChange, onSubmit, buttons = true }) => {
  return (
    <Box display='flex' flexDirection='column' justifyContent='space-between' gap={2} marginY={1} padding={3}>
      <span>Precios</span>
      <Box display='flex' flexDirection='row' justifyContent='space-between'>
        <CustomNumberInput
          symbol
          labelText='Compra '
          value={prices?.list_price}
          //onChange={handleChange}
          onChange={(event, newValue) => {
            event.preventDefault();
            onChange('prices.list_price', newValue);
          }}
        />
        <CustomNumberInput
          symbol
          labelText='Venta '
          value={prices?.sale_price}
          //onChange={handleChange}
          onChange={(event, newValue) => {
            event.preventDefault();
            onChange('prices.sale_price', newValue);
          }}
        />
      </Box>
      {buttons && <Box sx={{ mt: 5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Button
          type="submit"
          variant="outlined"
          onClick={onClose}
        >Aceptar</Button>
        {/* <Button
          type="submit"
          variant="outlined"
          // disabled={!isValid}
        >Guardar</Button> */}
      </Box>}
    </Box>
  );
}

export default FormPrecio;